//src/analytics/AnalyticsContext.js
import React, { createContext, useContext } from 'react';

export const AnalyticsContext = createContext({
  trackEvent: () => {},
  identifyUser: () => {},
  startSession: () => {},
  endSession: () => {},
});

export function useAnalytics() {
  return useContext(AnalyticsContext);
}
